export const LayoutGridThreeCols = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return <div className="grid md:grid-cols-3 gap-12">{children}</div>;
};
